<template>
  <b-card>

    <b-row>

      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
        <div class="d-flex justify-content-start">

          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ planningOrder.order.clinic.user.first_name }}
              </h4>
              <h5>{{ planningOrder.order.clinic.user.last_name }}</h5>
              <span class="card-text">{{ planningOrder.order.clinic.city.name }}, {{ planningOrder.order.clinic.department.name }}</span>
            </div>
            <!--            <div class="d-flex flex-wrap">
              <b-button
                variant="primary"
              >
                Edit
              </b-button>
              <b-button
                variant="outline-danger"
                class="ml-1"
              >
                Delete
              </b-button>
            </div>-->
          </div>
        </div>

        <!--        <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="DollarSignIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                23.3k
              </h5>
              <small>Monthly Sales</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
              variant="light-success"
              rounded
            >
              <feather-icon
                icon="TrendingUpIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                $99.87k
              </h5>
              <small>Annual Profit</small>
            </div>
          </div>
        </div>-->
      </b-col>

      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>

            <th class="pb-50">
              <feather-icon
                icon="HashIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Número de planificación</span>
            </th>
            <td class="pb-50">
              {{ planningOrder.order.planning_number }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Odontólogo</span>
            </th>
            <td class="pb-50">
              {{ planningOrder.order.dentist.full_name }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserCheckIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Paciente</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ planningOrder.order.patient.full_name }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CalendarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Fecha de creación</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ formatDateVariant(planningOrder.order.created_at) }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { formatDate } from '@/helpers/utils'

export default {
  components: {
    BBadge,
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
  },
  props: {
    planningOrder: {
      type: Object,
      required: true,
    },
  },
  setup() {
  },
  computed: {
    formatDateVariant() {
      return date => formatDate(date)
    },
  },
}
</script>

<style>

</style>
